import { formatAsUriParameters, getAsJson } from '@namespace/helpers';
import {
  Config,
  DepositCryptoAddress,
  GetDepositCryptoAddressParams,
  QueryParams,
  WithdrawalWallet
} from './types';

export const getWithdrawalWalletList = (
  config: Config = {} as Config,
  queryParams: QueryParams
) => {
  const { prefix, version = 'v1' } = config;
  return getAsJson<{ response: WithdrawalWallet[] }>(
    `/accounting/api/${version}/payment-info/${prefix}/withdrawal-crypto-address-history?${formatAsUriParameters(
      queryParams
    )}`
  ).then(({ response }) => response);
};

export const getDepositCryptoAddress = (
  params: GetDepositCryptoAddressParams
) => {
  const { userId, serviceId, ...queryParams } = params;
  return getAsJson<{ response: DepositCryptoAddress }>(
    `/accounting/api/v1/users/${userId}/payments/${serviceId}/deposit_address?${formatAsUriParameters(
      queryParams
    )}`
  ).then(({ response }) => response);
};
